import { useState } from 'preact/hooks';
import { ptpCatchError } from 'services/sentry.services';
import { ErrorCodes } from 'constants/errors.constants';
import { isRuntimeError } from 'utils/fetcher.utils';
import { cancelReturn } from '../services';

const useCancel = ({
  orgId,
  returnUuid,
  returnStatus,
}: {
  orgId: number;
  returnUuid: string;
  returnStatus: string;
}) => {
  const [process, setProcess] = useState<{
    loading?: boolean;
    success?: boolean;
    error?: Error;
  }>({});
  const onCancel = async () => {
    try {
      setProcess({ loading: true });
      await cancelReturn({ orgId, returnUuid, returnStatus });
      setProcess({ success: true });
    } catch (error) {
      if (isRuntimeError(error)) {
        ptpCatchError(error);
        setProcess({ error: new Error(ErrorCodes.GeneralError) });
      }
      setProcess({ error });
    }
  };
  return { onCancel, process };
};

export { useCancel };
